/**
 * Builds a react-router "to" location that passes a user's id (email) via in-memory
 * router state instead of the URL, so it never appears in the browser URL, history,
 * proxy logs, or server logs.
 *
 * Destination components must read `props.location.state.userId` and redirect back
 * to the list page (with an explanatory message) if state is missing, since state
 * does not survive a direct link open, bookmark, or hard refresh.
 */
export function userIdentityLinkTo(pathname, userId) {
    return { pathname, state: { userId } };
}
